"use strict";

exports.__esModule = true;
exports.createXScaleForBinnedBar = exports.createXScale = void 0;
var _scales = require("../../../Charts/scales");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var createXScale = exports.createXScale = function createXScale(from, to, series, options) {
  var padding = options.padding;
  var collected = [];
  var data = series[0].data;
  for (var _iterator = _createForOfIteratorHelperLoose(data), _step; !(_step = _iterator()).done;) {
    var key = _step.value.key;
    collected.push(key);
  }
  return (0, _scales.createBandScale)(from, to, collected, padding);
};
var createXScaleForBinnedBar = exports.createXScaleForBinnedBar = function createXScaleForBinnedBar(from, to, series, options) {
  var majorBarSize = options.majorBarSize,
    paddingBetweenMajorBars = options.paddingBetweenMajorBars;
  var collected = [];
  for (var _iterator2 = _createForOfIteratorHelperLoose(series), _step2; !(_step2 = _iterator2()).done;) {
    var data = _step2.value.data;
    for (var _iterator3 = _createForOfIteratorHelperLoose(data), _step3; !(_step3 = _iterator3()).done;) {
      var key = _step3.value.key;
      collected.push(key);
    }
  }
  var padding = paddingBetweenMajorBars / (majorBarSize + paddingBetweenMajorBars);
  return (0, _scales.createBandScale)(from, to, collected, padding);
};